import React from 'react';
import Icon from '../../../components/AppIcon';

const BlockHoursCard = ({ blockHours }) => {
  const periods = [
    { label: '30d', days: 30, color: 'text-accent-cyan' },
    { label: '60d', days: 60, color: 'text-accent-blue' },
    { label: '90d', days: 90, color: 'text-accent-purple' },
    { label: '180d', days: 180, color: 'text-accent-pink' },
    { label: '1yr', days: 360, color: 'text-warning' },
  ];

  return (
    <div className="card col-span-1 md:col-span-2 lg:col-span-2 hover:scale-[1.01] shadow-[0_0_10px_rgba(168,85,247,0.3)]">
      <div className="flex items-center gap-3 mb-3">
        <div className="flex items-center justify-center w-10 h-10 rounded-xl border border-accent-purple/20 bg-accent-purple/10">
          <Icon name="Timer" size={20} color="var(--color-accent-purple)" />
        </div>
        <h3 className="text-sm font-caption text-muted-foreground">
          Rolling Block Hours
        </h3>
      </div>
      
      <div className="grid grid-cols-5 gap-1 md:gap-2">
        {periods.map(({ label, days, color }) => (
          <div key={days} className="text-center p-1 md:p-2 rounded-lg bg-surface-elevated/50">
            <div className={`text-lg md:text-xl lg:text-2xl font-bold font-data ${color}`}>
              {(blockHours?.[days] || 0).toFixed(1)}
            </div>
            <div className="text-[10px] md:text-xs text-muted-foreground mt-0.5">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlockHoursCard;
